// import React from 'react'
// import './LoginPage.css'
// import { Tabs } from 'antd'
// import { Document, Page, pdfjs } from 'react-pdf'
// pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`

// import { Worker, Viewer, SpecialZoomLevel } from '@react-pdf-viewer/core'
// import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout'

// import '@react-pdf-viewer/core/lib/styles/index.css'
// import '@react-pdf-viewer/default-layout/lib/styles/index.css'
// const { TabPane } = Tabs

// const LandingPage = () => {
//   return (
//     <div style={{margin: '20px 50px 0px 50px', backgroundColor: '#fff', padding: '20px', borderRadius: '10px'}}>
//       <Tabs defaultActiveKey="1" onChange={(key) => console.log('Selected tab:', key)}>
//     <TabPane tab="Chính sách bảo mật thông tin" key="1">
//   <div style={{ height: '80vh' }}>
//   <Worker workerUrl={`https://unpkg.com/pdfjs-dist@2.13.216/build/pdf.worker.min.js`}>
//   <Viewer
//           fileUrl="pdf/chinh-sach-bao-mat-thong-tin.pdf"
//           plugins={[defaultLayoutPlugin()]}
//           defaultScale={SpecialZoomLevel.ActualSize}
//         />
//       </Worker>
//     </div>
//     </TabPane>
//     <TabPane tab="Điều khoản thoả thuận" key="2">
//     <div style={{ height: '80vh' }}>
//   <Worker workerUrl={`https://unpkg.com/pdfjs-dist@2.13.216/build/pdf.worker.min.js`}>
//   <Viewer
//           fileUrl="pdf/dieu-khoan-thoa-thuan.pdf"
//           plugins={[defaultLayoutPlugin()]}
//           defaultScale={SpecialZoomLevel.ActualSize}
//         />
//       </Worker>
//     </div>
//     </TabPane>
//     <TabPane tab="Giải quyết khiếu nại" key="3">
//     <div style={{ height: '80vh' }}>
//   <Worker workerUrl={`https://unpkg.com/pdfjs-dist@2.13.216/build/pdf.worker.min.js`}>
//   <Viewer
//           fileUrl="pdf/giai-quyet-khieu-nai.pdf"
//           plugins={[defaultLayoutPlugin()]}
//           defaultScale={SpecialZoomLevel.ActualSize}
//         />
//       </Worker>
//     </div>
//     </TabPane>
//     <TabPane tab="Quy chế hoạt động" key="4">
//     <div style={{ height: '80vh' }}>
//   <Worker workerUrl={`https://unpkg.com/pdfjs-dist@2.13.216/build/pdf.worker.min.js`}>
//   <Viewer
//           fileUrl="pdf/quy-che-hoat-dong.pdf"
//           plugins={[defaultLayoutPlugin()]}
//           defaultScale={SpecialZoomLevel.ActualSize}
//         />
//       </Worker>
//     </div>
//     </TabPane>
//     <TabPane tab="Quy định chung" key="5">
//     <div style={{ height: '80vh' }}>
//   <Worker workerUrl={`https://unpkg.com/pdfjs-dist@2.13.216/build/pdf.worker.min.js`}>
//   <Viewer
//           fileUrl="pdf/quy-dinh-chung.pdf"
//           plugins={[defaultLayoutPlugin()]}
//           defaultScale={SpecialZoomLevel.ActualSize}
//         />
//       </Worker>
//     </div>
//     </TabPane>
//   </Tabs>
//     </div>
//   )
// }

// export default LandingPage


import React from 'react'
import './LoginPage.css'
import { Tabs } from 'antd'
import { Worker, Viewer, SpecialZoomLevel } from '@react-pdf-viewer/core'
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout'

import '@react-pdf-viewer/core/lib/styles/index.css'
import '@react-pdf-viewer/default-layout/lib/styles/index.css'

const { TabPane } = Tabs

export const ViewerComponent = ({ fileUrl }) => {
  const plugin = defaultLayoutPlugin()

  return (
    <div style={{ height: '90vh' }}>
      <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.13.216/build/pdf.worker.min.js">
        <Viewer
          fileUrl={fileUrl}
          plugins={[plugin]}
          defaultScale={SpecialZoomLevel.ActualSize}
        />
      </Worker>
    </div>
  )
}

const TABS = [
  { key: '1', label: 'Chính sách bảo mật thông tin', file: 'pdf/chinh-sach-bao-mat-thong-tin.pdf' },
  { key: '2', label: 'Điều khoản thoả thuận', file: 'pdf/dieu-khoan-thoa-thuan.pdf' },
  { key: '3', label: 'Giải quyết khiếu nại', file: 'pdf/giai-quyet-khieu-nai.pdf' },
  { key: '4', label: 'Quy chế hoạt động', file: 'pdf/quy-che-hoat-dong.pdf' },
  { key: '5', label: 'Quy định chung', file: 'pdf/quy-dinh-chung.pdf' },
]

const LandingPage = () => (
  <div style={{ margin: '20px 50px 0px', backgroundColor: '#fff', padding: '20px', borderRadius: '10px' }}>
    <Tabs defaultActiveKey="1">
      {TABS.map(({ key, label, file }) => (
        <TabPane tab={label} key={key}>
          <ViewerComponent fileUrl={file} />
        </TabPane>
      ))}
    </Tabs>
  </div>
)

export default LandingPage
